import { useContext } from "react";

import type { MayaSpaceConfig } from "../spaces";

import { MayaSpaceContext } from "./space-context";

export const useMayaSpace = (): MayaSpaceConfig => {
  const ctx = useContext(MayaSpaceContext);
  if (!ctx) {
    throw new Error("useMayaSpace must be used within MayaSpaceContext");
  }
  return ctx;
};
